import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import UserRequestBanner from "./UserRequestBanner";
import UserRequestModal from "./UserRequestModal";
import { useGetUserRequest } from "./hooks/useGetUserRequest";

function UserRequestContainer(props) {
  var prefix = props.prefix,
      translate = props.translate;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useGetUserRequest = useGetUserRequest(isOpen),
      isFetching = _useGetUserRequest.isLoading,
      requestIds = _useGetUserRequest.requestIds,
      requests = _useGetUserRequest.requests,
      refresh = _useGetUserRequest.refresh;

  return /*#__PURE__*/React.createElement(React.Fragment, null, requestIds.length > 0 && /*#__PURE__*/React.createElement(UserRequestBanner, {
    prefix: prefix,
    translate: translate,
    userRequestNumber: requestIds.length,
    onOpen: function onOpen() {
      setIsOpen(true);
    }
  }), isOpen && /*#__PURE__*/React.createElement(UserRequestModal, {
    prefix: prefix,
    translate: translate,
    isOpen: isOpen,
    isFetching: isFetching,
    requestIds: requestIds,
    requests: requests,
    onRefresh: refresh,
    onClose: function onClose() {
      setIsOpen(false);
    }
  }));
}

export default UserRequestContainer;